import { Component, Input } from '@angular/core';

@Component({
  selector: 'navaar-chevron-icon',
  template: `
  <svg id="Icon-Chevron-Left" [ngStyle]="style" xmlns="http://www.w3.org/2000/svg" width="4.91" height="8.515" viewBox="0 0 4.91 8.515">
      <path id="Fill-35" d="M-208.611-307.885l.622-.622-3.667-3.636,3.667-3.636-.622-.622-4.289,4.258,4.289,4.258" transform="translate(212.9 316.4)" [attr.fill]="color"/>
    </svg>`
})
export class ChevronIconComponent  {
  @Input() public color: string = '#fff';
  @Input() public style: object = {};
  constructor() { }
}
